import React, {Component} from 'react';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush} from 'recharts';
import * as formatter from "../utils/formatters";
import {COLORS, GRAPH_MARGIN} from "../utils/constants";

class PotentialBillingIncreaseGraph extends Component{

  constructor(props){
    super(props)
    this.state={data:this.props.data}
  }

  render(){

    return(
      <ResponsiveContainer>
        <LineChart width={600} height={300} data={this.state.data} margin={GRAPH_MARGIN}>
          <XAxis dataKey = "month"/>
          <YAxis tickFormatter={formatter.formatNumber} scale={'linear'}/>
          <CartesianGrid/>
          <Tooltip formatter={formatter.formatNumber}/>
          <Legend verticalAlign={"top"}/>
          <Line name={"MDP"} type="linear" dataKey="current" stroke={COLORS.AMOUNT} />
          <Brush height={20}/>
        </LineChart>
      </ResponsiveContainer>
    );
  }
}

export default PotentialBillingIncreaseGraph;



// WEBPACK FOOTER //
// ./src/charts/potentialBillingIncreaseGraph.js